import { NgModule } from '@angular/core';
import { S102gS102m01Component } from './s102g-s102m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S102gS102m01Component]
})
export class S102gModule { }

